import {UserMannerCodeEnum, UserMannerTypeEnum} from "./Type";

export interface GetUserMannerAPIResInterface {
	point: number;
	countGreatAndGood: number;
	countLastDays: number;
	detailCount: number;
	detailList: {
		id: string;
		createDate: Date;
		updateDate: Date;
		type: UserMannerTypeEnum;
		code: UserMannerCodeEnum;
		message: string;
		count: number;
		isValid: boolean;
	}[];
}

export const emptyUserMannerAPIRes: GetUserMannerAPIResInterface = {
	point: 0,
	countGreatAndGood: 0,
	countLastDays: 0,
	detailCount: 0,
	detailList: []
};